export const CYPRESS_DATA_ATTRIBUTE_NAME = "data-cy";

export const CypressDataAttributes = Object.freeze({
  MOTOR_SIZE_SELECTOR_WIDGET: "motor-selector-widget",
  CURRENT_CONFIGURATION_WIDGET: "current-widget",
  HOMING_SPEED_WIDGET: "homing-speed-widget",
  BRAKE_CHECKBOX_WIDGET: "brake-checkbox-widget",
  GEARBOX_CHECKBOX_WIDGET: "gearbox-checkbox-widget",
});